import React, { useEffect } from "react";
import StoryViewsExitsCharts from "./StoryViewsExitsCharts";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function StoryViewsExits(props) {
    const chartLoading = props.chartDataLoading?.insta_story;
    // const isNoData = Object.keys(props.chartData?.insta_story?.views_data || {}).length === 0;
    const isNoData = props.pageStatus || props.chartData?.insta_story?.nodata;
    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    return (
        <>
            {chartLoading && <Loading />}
            {!isNoData && !chartLoading && (
                <StoryViewsExitsCharts
                    chartData={props.chartData}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    graphType={props.graphType}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                    showAverage={props.showAverage}
                />
            )}
            {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}

export default StoryViewsExits;
